"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconHousePlus = function IconHousePlus(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.7 11.4005H24.6V9.30051C24.6 9.06182 24.5052 8.8329 24.3364 8.66412C24.1676 8.49533 23.9387 8.40051 23.7 8.40051C23.4613 8.40051 23.2324 8.49533 23.0636 8.66412C22.8948 8.8329 22.8 9.06182 22.8 9.30051V11.4005H20.7C20.4613 11.4005 20.2324 11.4953 20.0636 11.6641C19.8948 11.8329 19.8 12.0618 19.8 12.3005C19.8 12.5392 19.8948 12.7681 20.0636 12.9369C20.2324 13.1057 20.4613 13.2005 20.7 13.2005H22.8V15.3005C22.8 15.5392 22.8948 15.7681 23.0636 15.9369C23.2324 16.1057 23.4613 16.2005 23.7 16.2005C23.9387 16.2005 24.1676 16.1057 24.3364 15.9369C24.5052 15.7681 24.6 15.5392 24.6 15.3005V13.2005H26.7C26.9387 13.2005 27.1676 13.1057 27.3364 12.9369C27.5052 12.7681 27.6 12.5392 27.6 12.3005C27.6 12.0618 27.5052 11.8329 27.3364 11.6641C27.1676 11.4953 26.9387 11.4005 26.7 11.4005Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.7 17.4005C23.1431 17.4005 22.6089 17.1793 22.2151 16.7854C21.8213 16.3916 21.6 15.8575 21.6 15.3005V14.4005H20.7C20.1431 14.4005 19.6089 14.1793 19.2151 13.7854C18.8213 13.3916 18.6 12.8575 18.6 12.3005C18.6 11.7435 18.8213 11.2094 19.2151 10.8156C19.6089 10.4218 20.1431 10.2005 20.7 10.2005H21.6V6.4865C21.6 6.32737 21.5368 6.17476 21.4243 6.06224C21.3118 5.94972 21.1591 5.8865 21 5.8865H18.6C18.4409 5.8865 18.2883 5.94972 18.1757 6.06224C18.0632 6.17476 18 6.32737 18 6.4865V7.2905L15.33 5.4905C15.232 5.42599 15.1173 5.3916 15 5.3916C14.8827 5.3916 14.768 5.42599 14.67 5.4905L6.27001 11.1245C6.18662 11.1794 6.11826 11.2543 6.07111 11.3423C6.02396 11.4303 5.99952 11.5287 6.00001 11.6285V24.0005C6.00001 24.1596 6.06322 24.3122 6.17574 24.4248C6.28826 24.5373 6.44088 24.6005 6.60001 24.6005H10.2V18.6005C10.2 18.4414 10.2632 18.2888 10.3757 18.1762C10.4883 18.0637 10.6409 18.0005 10.8 18.0005H13.8C13.9591 18.0005 14.1117 18.0637 14.2243 18.1762C14.3368 18.2888 14.4 18.4414 14.4 18.6005V24.6005H23.4C23.5591 24.6005 23.7118 24.5373 23.8243 24.4248C23.9368 24.3122 24 24.1596 24 24.0005V17.4005C23.9002 17.4096 23.7998 17.4096 23.7 17.4005Z",
    fill: color
  }));
};

IconHousePlus.defaultProps = {
  color: 'black'
};
IconHousePlus.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconHousePlus;
exports.default = _default;